import { produce } from 'immer'
import { updateProfilePhotoRouteProps } from 'src/navigation/routeProps'
import {
  POST_USER_AVATAR_FAILURE,
  POST_USER_AVATAR_INIT,
  POST_USER_AVATAR_SUCCESS,
  PostUserAvatarActions,
} from 'src/redux/actions/data/users.actions'
import { createFlyoutReducer } from 'src/redux/genericReducers'
import { parseBackendErrors } from 'src/utils/error.utils'

export interface UpdateProfilePhotoState {
  postingAvatar: boolean
  postingAvatarTopLevelError?: string
}

export const initialState: UpdateProfilePhotoState = {
  postingAvatar: false,
}

export type Actions = PostUserAvatarActions

const CoreUpdateProfilePhotoReducer = (
  state = initialState,
  action: Actions,
): UpdateProfilePhotoState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case POST_USER_AVATAR_INIT: {
        draft.postingAvatar = true
        draft.postingAvatarTopLevelError = undefined
        return draft
      }

      case POST_USER_AVATAR_SUCCESS: {
        draft.postingAvatar = false
        return draft
      }

      case POST_USER_AVATAR_FAILURE: {
        const topLevelError =
          typeof action.payload === 'string'
            ? action.payload
            : parseBackendErrors(action.payload).topLevelError

        draft.postingAvatar = false
        draft.postingAvatarTopLevelError = topLevelError
        return draft
      }
    }
  })
}

const UpdateProfilePhotoReducer = createFlyoutReducer(
  updateProfilePhotoRouteProps,
  initialState,
  CoreUpdateProfilePhotoReducer,
)

export default UpdateProfilePhotoReducer
